import { render, staticRenderFns } from "./NovelCreateForm.vue?vue&type=template&id=63dd980e&scoped=true"
import script from "./NovelCreateForm.vue?vue&type=script&lang=ts"
export * from "./NovelCreateForm.vue?vue&type=script&lang=ts"
import style0 from "./NovelCreateForm.vue?vue&type=style&index=0&id=63dd980e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd980e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63dd980e')) {
      api.createRecord('63dd980e', component.options)
    } else {
      api.reload('63dd980e', component.options)
    }
    module.hot.accept("./NovelCreateForm.vue?vue&type=template&id=63dd980e&scoped=true", function () {
      api.rerender('63dd980e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NovelCreateForm.vue"
export default component.exports